import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
const applyPromotionalItem = outputCartData => promotionalItem => {
  if (promotionalItem.selection.tag === "UserEnabled" || promotionalItem.selection.tag === "AutoEnabled") {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dCartData.addToTotal((() => {
      if (promotionalItem.value.tag === "Nothing") { return 0; }
      if (promotionalItem.value.tag === "Just") { return promotionalItem.value._1; }
      $runtime.fail();
    })())(outputCartData);
    if (promotionalItem.promotion.prize.tag === "Freeby") {
      return {...$0, allFreeProducts: Data$dSemigroup.concatArray([promotionalItem.promotion.prize._1])($0.allFreeProducts)};
    }
    return $0;
  }
  return outputCartData;
};
const evaluateCart = inputCartData => promotionalItems => Data$dFoldable.foldlArray(applyPromotionalItem)(Restaumatic$dPromotionsEngine$dCart$dCartData.mkDefaultOutputCartData(inputCartData)(promotionalItems))(promotionalItems);
export {applyPromotionalItem, evaluateCart};
